export default "__VITE_ASSET__Dz4a0FEe__"